/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_503Inputs */

const vi_carrier_status_503 = /** @type {(inputs: Carrier_Status_503Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu huỷ theo yêu cầu khách`)
};

/**

* @param {Carrier_Status_503Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_503 = /** @type {((inputs?: Carrier_Status_503Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_503Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_503(inputs)
});